module.exports = __webpack_public_path__ + "img/upperCaseT.1dfaf3a1.svg";